import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs';
import { environment } from '../../../environments/environment';
import { SessionService } from '../../Util/Session/session.service';

@Injectable({
  providedIn: 'root'
})
export class AttendanceDeviceService {

  constructor(
    private http: HttpClient,
    private session: SessionService,
  ) {
    environment.API_URL = this.session.GetUserDetails().ApiUrl;
  }

  ESS_SiteWiseDeviceDetailsSelect(Detail: any) {
    return this.http.post<any>(environment.API_URL + `ESS_SiteWiseDeviceDetails/Select`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  ESS_SiteWiseDeviceDetails_InsertUpdate(Detail: any) {
    return this.http.post<any>(environment.API_URL + `ESS_SiteWiseDeviceDetails_Insert/Update`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  ESS_EmpWiseSiteWiseDeviceDetails_Selectget(Detail: any) {
    return this.http.post<any>(environment.API_URL + `ESS_EmpWiseSiteWiseDeviceDetails_Select/get`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  ESS_EmpWiseSiteWiseDeviceDetailsUpdate(Detail: any) {
    return this.http.post<any>(environment.API_URL + `ESS_EmpWiseSiteWiseDeviceDetails/Update`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  Ess_DeviceEmployeeDeletes(Detail: any) {
    return this.http.post<any>(environment.API_URL + `Ess_DeviceEmployee/Deletes`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  GetDeviceCompanyCode(Detail: any) {
    return this.http.post<any>(environment.API_URL + `GetDevice/CompanyCode`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }
}